import React, { FC } from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  RadioGroupProps,
  Radio,
  makeStyles,
  createStyles,
} from '@material-ui/core';

import {
  StyledInputLabel,
  StyledHelperText,
} from '@bizapp-lp/pjr/molecules/StyledInput';

export interface StyledRadioGroupProps extends RadioGroupProps {
  label?: React.ReactNode;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  options: Map<string, React.ReactNode>;
  helperText?: React.ReactNode;
  description?: React.ReactNode;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'block',
    },
    radioGroup: {
      marginTop: theme.spacing(0.75),
      '& .MuiRadio-root': { color: '#787F86' },
      '& .Mui-checked': { color: '#787F86' },
    },
    radio: {
      padding: theme.spacing(0),
      marginTop: '2px',
      marginRight: theme.spacing(1),
      marginBottom: '3px',
      '& svg': {
        width: '16px',
        height: '16px',
      },
    },
    ctrLabel: {
      margin: theme.spacing(1, 0, 0, 0),
      '&:first-child': {
        marginTop: 0,
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        letterSpacing: 0,
      },
    },

    description: {
      marginTop: '6px',
      fontSize: '14px',
      color: '#7F7F7F',
    },
  }),
);

export const StyledRadioGroup: FC<StyledRadioGroupProps> = ({
  className = '',
  id,
  label,
  required = false,
  error = false,
  disabled = false,
  options,
  helperText,
  description,
  ...props
}) => {
  const classes = useStyles();

  return (
    <FormControl
      component="fieldset"
      required={required}
      error={error}
      disabled={disabled}
      className={`${classes.root} ${className}`}
    >
      {label && <StyledInputLabel htmlFor={id}>{label}</StyledInputLabel>}
      <RadioGroup {...props} className={classes.radioGroup}>
        {Array.from(options.entries()).map((kv, i) => {
          const [key, value] = kv;
          return (
            <FormControlLabel
              value={key}
              control={<Radio className={classes.radio} />}
              label={value}
              key={`${id}-${i}`}
              className={classes.ctrLabel}
            />
          );
        })}
      </RadioGroup>
      {helperText && error && <StyledHelperText children={helperText} />}
      {description && (
        <Box children={description} className={classes.description} />
      )}
    </FormControl>
  );
};
